module.exports = __webpack_public_path__ + "20260128d142218t/img/learning-cuate-icon.044b9169.png";